<app-popover>
  <div app-popover-header>Envios</div>
  <hr app-divider />
  <div app-popover-content class="p-0!">
    @for (answer of answers$ | async; track answer) {
      <div
        app-button
        #popoverAnswers
        (click)="onSelect(answer)"
        class="flex w-full flex-col justify-start! bg-white p-2"
      >
        <div class="flex w-full items-center justify-start gap-2">
          <svg-icon class="w-2 text-base-whisper-900" src="assets/icons/icon-arrow-small.svg"></svg-icon>
          <p class="mb-1 text-base font-medium">
            {{ answer.created_at | date: 'medium' }}
          </p>
        </div>
      </div>
    }
  </div>
</app-popover>
